import React from 'react';
export default function HardBreak() {
    return React.createElement("br", null);
}
//# sourceMappingURL=hardBreak.js.map